export const getNodeId = (selectedNode: string): number => {
  const splitNodeName = selectedNode.split('-');
  return !isNaN(Number(splitNodeName[1]))
    ? Number(Number(splitNodeName[1]))
    : -1;
};

export const checkIfEditDeleteDisabled = (selectedNode: string) => {
  return (
    !selectedNode ||
    selectedNode === 'satellite-0' ||
    selectedNode === 'location-0' ||
    selectedNode === 'dish-0' ||
    selectedNode === 'switch-0' ||
    selectedNode === 'analyzer-0' ||
    selectedNode.startsWith('satelliteDish') ||
    selectedNode.startsWith('locationDish') ||
    selectedNode.startsWith('dishSwitch') ||
    selectedNode.startsWith('switchAnalyzer') ||
    selectedNode.startsWith('dishAnalyzer')
  );
};
